// extracted by mini-css-extract-plugin
module.exports = {"root":"ImageBlock_root__XVKxb","imgWrap":"ImageBlock_imgWrap__WyBBf","text":"ImageBlock_text__u2V6k"};